import { isAxiosError } from 'axios'

/**
 * Messaggio leggibile per un errore delle chiamate alle API.
 * Usa il messaggio restituito dal backend ({ error: { message } }, { detail } o { message }),
 * anche quando la risposta è un ArrayBuffer (download di file); altrimenti il messaggio dell'errore o il fallback.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (!isAxiosError(error)) {
    return error instanceof Error && error.message ? error.message : fallback
  }

  let data: unknown = error.response?.data
  if (data instanceof ArrayBuffer) data = new TextDecoder().decode(data)

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data)
    } catch {
      // Le risposte non JSON (ad es. un errore HTML del proxy) usano il messaggio della richiesta.
      data = undefined
    }
  }

  if (data && typeof data === 'object') {
    const response = data as { error?: { message?: unknown }; message?: unknown; detail?: unknown }
    const message = response.error?.message ?? response.detail ?? response.message
    if (typeof message === 'string' && message.trim()) return message
  }

  return error.message || fallback
}
